import { SET_DEPOSIT_INVOICES } from 'store/types/depositInvoice';

const initialState = {
  depositInvoices: [],
};

const depositInvoice = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEPOSIT_INVOICES:
      return {
        ...state,
        depositInvoices: action.payload,
      };

    default:
      return state;
  }
};

export default depositInvoice;
